import { IAlertTypeItemData, IGroupInfo } from "@home-health-notify/domain";
import { Box, Divider, List } from "@mui/material";
import React from "react";
import EmptyRecordView from "../../common/EmptyRecordView";
import GoToTop from "../../common/GoToTop";
import ScrollListContainer from "../../common/ScrollListContainer";
import { useScrollAnchor } from "../../hooks/useScrollAnchor";
import ReferralAlertItem from "./ReferralAlertItem";

const ReferralAlertContent = ({
  referralData,
}: {
  referralData: IAlertTypeItemData[];
}) => {
  const { scrollContainerRef, isShowGoToTopButton, goToTop } = useScrollAnchor({
    items: referralData,
    getItemId: item => item.referralId || "",
    disableScrollCompensation: true,
  });

  return (
    <ScrollListContainer
      ref={scrollContainerRef}
      dataTestId="pending-referrals-list"
    >
      <>
        {isShowGoToTopButton && <GoToTop onClick={goToTop} />}
        <List sx={{ width: "100%" }}>
          {referralData && referralData.length > 0 ? (
            referralData.map((referralItem: IAlertTypeItemData, index) => {
              const groupInfo = referralItem.info as IGroupInfo;
              return (
                <Box
                  key={referralItem.referralId}
                  data-testid="pending-referral-item"
                >
                  {index > 0 && <Divider component="li" />}
                  <ReferralAlertItem
                    groupInfo={groupInfo}
                    referralItem={referralItem}
                  />
                </Box>
              );
            })
          ) : (
            <EmptyRecordView />
          )}
        </List>
      </>
    </ScrollListContainer>
  );
};

export default ReferralAlertContent;
